import LoadingBox from 'components/Common/Loading/LoadingBox'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButtonLoadingSkeleton from 'LuxKit/Button/TextButtonLoadingSkeleton'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import Group from 'components/utils/Group'
import styled from 'styled-components'
import _SearchTileBase from './_SearchTileBase'
import _SearchTileContent from './_SearchTileContent'
import _SearchTileContentSecondary from './_SearchTileContentSecondary'
import _SearchTilePricing from './_SearchTilePricing'
import OfferDescriptionLoadingSkeleton from 'components/Common/Loading/OfferDescriptionLoadingSkeleton'
import { useAppSelector } from 'hooks/reduxHooks'
import getOfferListKey from 'lib/offer/offerListKey'
import { useShouldShowOfferDescription } from 'lib/offer/offerDescriptionUtils'
import type { SearchTileDensity, SearchTileTreatment } from './searchTileDensity'

const Primary = styled(Group)`
  grid-area: content-primary;
`

const Hero = styled(LoadingBox)`
  grid-area: hero;
`

interface Props {
  filters?: App.OfferListFilters
  offerPosition?: number
  className?: string
  searchTileDensity?: SearchTileDensity
  searchTileTreatment?: SearchTileTreatment
}

function LoadingSearchTileSkeleton({
  filters,
  offerPosition,
  className,
  searchTileDensity = 'default',
  searchTileTreatment = 'default',
}: Props) {
  const descriptionLoading = useAppSelector((state) => state.offer.offerLists[filters ? getOfferListKey(filters) : '']?.descriptionLoading)
  const shouldShowDescription = useShouldShowOfferDescription(offerPosition, descriptionLoading)
  const offerDescBanner = shouldShowDescription ? <OfferDescriptionLoadingSkeleton /> : false

  return <_SearchTileBase
    banner={offerDescBanner}
    className={className}
    density={searchTileDensity}
    treatment={searchTileTreatment}
  >
    <Hero />
    <_SearchTileContent density={searchTileDensity}>
      <Primary direction="vertical" gap={12}>
        <VerticalSpacer gap={4}>
          <TextLoadingBox typography="body-small" width="20ch" />
          <TextLoadingBox typography="heading5" width="100%" lines={2} />
          <TextLoadingBox typography="body-medium" width="80%" />
        </VerticalSpacer>
      </Primary>
      <_SearchTileContentSecondary density={searchTileDensity}>
        <_SearchTilePricing
          action={<TextButtonLoadingSkeleton width="10ch" />}
          density={searchTileDensity}
        >
        </_SearchTilePricing>
      </_SearchTileContentSecondary>
    </_SearchTileContent>
  </_SearchTileBase>
}

export default LoadingSearchTileSkeleton
